import NavSelectPopper from './src/nav-select-popper';

NavSelectPopper.directive = NavSelectPopper.component.Popper.directive;

export default NavSelectPopper;
